import { Link } from 'gatsby';
import { default as React } from 'react';
import { Highlight, Index, Snippet, useHits } from 'react-instantsearch';
import LinkComponent from '../../utils/linkComponent';

const PageHit = (props) => {
	const { hits } = useHits(props);
	return (
		<>
			{hits.map((hit) => (
				<div key={hit.objectID}>
					<LinkComponent
						to={`${hit.slug}`}
						id={hit.objectID}
						onClick={() => {
							window.analytics.track('Link Clicked', {
								title: hit.name ? hit.name : null,
								link: hit.slug ? hit.slug : null,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: 'Page',
								static_component_title: 'Search Result',
								url: window.location.href,
								strapi_id: hit.strapi_id ? hit.strapi_id : null,
								matchedwords: hit._highlightResult?.name?.matchedWords
									? hit._highlightResult.name.matchedWords
									: null,
							});
							props.setFocus(false);
							props.setExpanded(false);
							props.setClearSearch(true);
						}}
					>
						<p style={{ marginBottom: '0.6rem' }}>
							<Highlight attribute='name' hit={hit} />
						</p>
					</LinkComponent>
					<Snippet attribute='excerpt' hit={hit} />
				</div>
			))}
		</>
	);
};

const EventHit = (props) => {
	const { hits } = useHits(props);
	return (
		<>
			{hits.map((hit) => (
				<div key={hit.objectID}>
					<LinkComponent
						to={`${hit.slug}`}
						id={hit.objectID}
						onClick={() => {
							window.analytics.track('Link Clicked', {
								title: hit.name ? hit.name : null,
								link: hit.slug ? hit.slug : null,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: 'Event',
								static_component_title: 'Search Result',
								url: window.location.href,
								strapi_id: hit.strapi_id ? hit.strapi_id : null,
								matchedwords: hit._highlightResult?.name?.matchedWords
									? hit._highlightResult.name.matchedWords
									: null,
							});
							props.setFocus(false);
							props.setExpanded(false);
							props.setClearSearch(true);
						}}
					>
						<p style={{ marginBottom: '0.6rem' }}>
							<Highlight attribute='name' hit={hit} />
						</p>
					</LinkComponent>
					<Snippet attribute='excerpt' hit={hit} />
				</div>
			))}
		</>
	);
};

const ResourceHit = (props) => {
	const { hits } = useHits(props);
	return (
		<>
			{hits.map((hit) => (
				<div key={hit.objectID}>
					<LinkComponent
						to={`${hit.slug}`}
						id={hit.objectID}
						onClick={() => {
							window.analytics.track('Link Clicked', {
								title: hit.name ? hit.name : null,
								link: hit.slug ? hit.slug : null,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: 'Resource',
								static_component_title: 'Search Result',
								url: window.location.href,
								strapi_id: hit.strapi_id ? hit.strapi_id : null,
								matchedwords: hit._highlightResult?.name?.matchedWords
									? hit._highlightResult.name.matchedWords
									: null,
							});
							props.setFocus(false);
							props.setExpanded(false);
							props.setClearSearch(true);
						}}
					>
						<p style={{ marginBottom: '0.6rem' }}>
							<Highlight attribute='name' hit={hit} />
						</p>
					</LinkComponent>
					<Snippet attribute='excerpt' hit={hit} />
				</div>
			))}
		</>
	);
};

const CyberSnippetHit = (props) => {
	const { hits } = useHits(props);
	return (
		<>
			{hits.map((hit) => (
				<div key={hit.objectID}>
					<a
						to={`${hit.external_source_url}`}
						href={hit.external_source_url}
						onClick={() => {
							props.setFocus(false);
							window.analytics.track('Link Clicked', {
								title: hit.name ? hit.name : null,
								link: hit.slug ? hit.slug : null,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: 'Cyber Snippet',
								static_component_title: 'Cyber Snippet',
								url: window.location.href,
								strapi_id: hit.strapi_id ? hit.strapi_id : null,
								matchedwords: hit._highlightResult?.name?.matchedWords
									? hit._highlightResult.name.matchedWords
									: null,
							});
							props.setFocus(false);
							props.setExpanded(false);
							props.setClearSearch(true);
						}}
					>
						<p style={{ marginBottom: '0.6rem' }}>
							<Highlight attribute='title' hit={hit} />
						</p>
					</a>
					<Snippet attribute='excerpt' hit={hit} />
				</div>
			))}
		</>
	);
};

const OfferHit = (props) => {
	const { hits } = useHits(props);
	return (
		<>
			{hits.map((hit) => (
				<div key={hit.objectID}>
					{/* 
            Instead of dynamically generating the URL from hit.slug and hit.panel,
            we now always redirect to /procurement/hub.
          */}
					<LinkComponent
						to='/procurement/portal'
						onClick={() => {
							window.analytics.track('Link Clicked', {
								title: hit.name ? hit.name : null,
								link: hit.slug ? hit.slug : null,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: `${hit.panel ? 'Panel' : 'Offer'}`,
								static_component: 'Search Result',
								url: window.location.href,
								strapi_id: hit.strapi_id ? hit.strapi_id : null,
								matchedwords: hit._highlightResult?.name?.matchedWords
									? hit._highlightResult.name.matchedWords
									: null,
							});
							props.setFocus(false);
							props.setExpanded(false);
							props.setClearSearch(true);
						}}
					>
						<p style={{ marginBottom: '0.6rem' }}>
							<Highlight attribute='name' hit={hit} />
						</p>
					</LinkComponent>
					<Snippet attribute='excerpt' hit={hit} />
				</div>
			))}
		</>
	);
};

const SurveyResultHit = (props) => {
	const { hits } = useHits(props);
	return (
		<>
			{hits.map((hit) => (
				<div key={hit.objectID}>
					<LinkComponent
						to={`/insights/survey-service/survey-results?query=${hit.survey_title}`}
						onClick={() => {
							window.analytics.track('Link Clicked', {
								title: hit.name ? hit.name : null,
								link: hit.slug ? hit.slug : null,
								path: window.location.pathname,
								report_type: 'New',
								collection_type: 'Survey Result',
								static_component_title: 'Search Result',
								url: window.location.href,
								strapi_id: hit.strapi_id ? hit.strapi_id : null,
								matchedwords: hit._highlightResult?.name?.matchedWords
									? hit._highlightResult.name.matchedWords
									: null,
							});
							props.setFocus(false);
							props.setExpanded(false);
							props.setClearSearch(true);
						}}
					>
						<p style={{ marginBottom: '0.6rem' }}>
							<Highlight attribute='survey_title' hit={hit} /> -{' '}
							<Highlight attribute='published_year' hit={hit} />
						</p>
					</LinkComponent>
					<Snippet attribute='survey_title' hit={hit} />
				</div>
			))}
		</>
	);
};

const HitsInIndex = ({
	index,
	user,
	setFocus,
	setExpanded,
	setClearSearch,
}) => (
	<Index indexName={index.name}>
		<h5
			style={{
				color: 'var(--secondary_6)',
				backgroundImage: `linear-gradient(
				  142deg,
				  rgba(175, 37, 45, 0.88) 32%,
				  rgba(23, 156, 163, 0.93) 55%,
				  rgba(183, 211, 54, 0.84) 87%
				)`,
				padding: '0.5em',
			}}
		>
			{index.title}
		</h5>
		{/* <HitCount /> */}
		{index.name === 'Resources' ? (
			<ResourceHit
				user={user}
				className='Hits'
				setFocus={setFocus}
				setExpanded={setExpanded}
				setClearSearch={setClearSearch}
			/>
		) : index.name === 'Pages' ? (
			<PageHit
				className='Hits'
				setFocus={setFocus}
				setExpanded={setExpanded}
				setClearSearch={setClearSearch}
			/>
		) : index.name === 'Events' ? (
			<EventHit
				className='Hits'
				setFocus={setFocus}
				setExpanded={setExpanded}
				setClearSearch={setClearSearch}
			/>
		) : index.name === 'CyberSnippets' ? (
			<CyberSnippetHit
				className='Hits'
				setFocus={setFocus}
				setExpanded={setExpanded}
				setClearSearch={setClearSearch}
			/>
		) : index.name === 'Offers' ? (
			<OfferHit
				className='Hits'
				setFocus={setFocus}
				setExpanded={setExpanded}
				setClearSearch={setClearSearch}
			/>
		) : index.name === 'PublicSurveyResults' ? (
			<SurveyResultHit
				className='Hits'
				setFocus={setFocus}
				setExpanded={setExpanded}
				setClearSearch={setClearSearch}
			/>
		) : null}
	</Index>
);

const SearchResult = ({
	indices,
	className,
	user,
	setFocus,
	setExpanded,
	setClearSearch,
}) => (
	<div className={className}>
		{indices.map((index) => (
			<HitsInIndex
				index={index}
				key={index.name}
				user={user}
				setFocus={setFocus}
				setExpanded={setExpanded}
				setClearSearch={setClearSearch}
			/>
		))}
	</div>
);

export default SearchResult;
